/** Pagination info. */
export class PaginationInfo {
  constructor(data) {
    /** @type {number} */
    this.count = data.count;

    /** @type {number} */
    this.currentPage = data.currentPage;

    /** @type {number} */
    this.nextPage = data.nextPage;

    /** @type {number} */
    this.previousPage = data.previousPage;

    /** @type {number} */
    this.total = data.total;

    /** @type {Array} */
    this.data = data.data;

    /** @type {number} */
    this.totalPages = data.totalPages;
  }
}

export const DEFAULT_PAGINATION_INFO = new PaginationInfo({
  count: 0,
  currentPage: 1,
  totalPages: 0,
  nextPage: null,
  previousPage: null,
  total: 0,
  data: [],
});
